import * as yup from "yup";

export const customerSocialReasonInitialValues = {
  rfc: "",
  fiscalRegimeId: "",
  cfdiId: "",
  postalCode: "",
  street: "",
  numExt: "",
  numInt: "",
  betweenStreet: "",
  andStreet: "",
  phone: "",
  lada_phone: "52",
  state: "",
  city: "",
  municipality: "",
  colonia: "",
  nationality: "",
  reference: "",
  email: "",
  country: "México",
  name: "",
};

export const customerSocialReasonValidationSchema = yup.object().shape({
  name: yup.string().required("El nombre es requerido"),
  rfc: yup
    .string()
    .required("Campo requerido")
    .matches(
      /^([A-Z,Ñ,&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/,
      "El RFC es inválido"
    ),
  fiscalRegimeId: yup
    .mixed()
    .test(
      "is-selected",
      "El régimen fiscal es requerido",
      (value) => value !== null && typeof value === "object" && !!value.id
    )
    .required("El régimen fiscal es requerido"),
  cfdiId: yup
    .mixed()
    .test(
      "is-selected",
      "El uso CFDI es requerido",
      (value) => value !== null && typeof value === "object" && !!value.id
    )
    .required("El uso CFDI es requerido"),
  postalCode: yup
    .string()
    .required("El código postal es requerido")
    .matches(/^\d{5}$/, "El código postal debe tener exactamente 5 dígitos numéricos"),
  phone: yup
  .string()
  .required("El teléfono es requerido")
  .matches(/^\(\d{3}\) \d{3}-\d{4}$/, "El formato del teléfono es inválido"),
  lada_phone: yup
    .string()
    .required("La lada es requerida"),
  email: yup
  .string()
  .required("El correo electrónico es requerido")
  .email("El formato del correo no es válido"),
});
